import {getCards} from "@/utils/net";
import {useRecoilValue} from "recoil";
import {cardsTypeAtom} from "@/store";
import {CardDataContext} from "@/utils/context";
import {RodinCard} from "../Card";
import {useRequest} from "@/utils/hooks";
import {useParams} from "react-router-dom";

const PrerenderGallery = () => {
  const cardsType = useRecoilValue(cardsTypeAtom);
  const params = useParams();
  const page = parseInt(params.page) ? parseInt(params.page) : 1;

  const {data: cards} = useRequest(
    async () => {
      return (
        await getCards({
          type: cardsType,
          page_num: page,
          task_step: ["ModelGenerate", "ModelRefine", "TextureGenerate", "TextureRefine"],
          user_type: "All",
          task_type: "Rodin",
        })
      ).data;
    },
    {
      initData: [],
    }
  );

  const pageGroupSize = 10;

  const currentGroup = Math.floor((page - 1) / pageGroupSize);

  const groupStart = currentGroup * pageGroupSize + 1;
  const groupEnd = groupStart + pageGroupSize - 1;

  const groupPages = [];
  for (let p = groupStart; p <= groupEnd; p++) {
    groupPages.push(p);
  }

  return (
    <div>
      {cards.map((card, index) => (
        <CardDataContext.Provider key={index} value={card}>
          <RodinCard keyIndex={index} card={card} cacheCardList={[]}/>
        </CardDataContext.Provider>
      ))}

      {cards.length && (
        <div style={{marginTop: 20}}>
          <a
            href={`https://${location.host}/rodin/page/${groupStart - 1}`}
            style={{marginRight: 8}}
          >
            Previous
          </a>

          {groupPages.map((num) => (
            <a
              key={num}
              href={`https://${location.host}/rodin/page/${num}`}
              style={{
                marginRight: 8,
                textDecoration: num === page ? "underline" : "none",
              }}
            >
              {num}
            </a>
          ))}

          <a
            href={`https://${location.host}/rodin/page/${groupEnd + 1}`}
            style={{marginRight: 8}}
          >
            Next
          </a>
        </div>
      )}
    </div>
  );
};

export default PrerenderGallery;
